<template>
  <path
    d="M14.43 10.0003L12.96 5.16025C12.67 4.21025 11.33 4.21025 11.05 5.16025L9.56996 10.0003H5.11996C4.14996 10.0003 3.74996 11.2503 4.53996 11.8103L8.17996 14.4103L6.74996 19.0203C6.45996 19.9503 7.53996 20.7003 8.30996 20.1103L12 17.3103L15.69 20.1203C16.46 20.7103 17.54 19.9603 17.25 19.0303L15.82 14.4203L19.46 11.8203C20.25 11.2503 19.85 10.0103 18.88 10.0103H14.43V10.0003Z"
  />
</template>
